import React from 'react';

type BeginingsIconProps = {
  width: string;
  height: string;
};

function BeginingsIcon({ width, height }: BeginingsIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 250 241'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_1032_1618)'>
        <path
          d='M103.006 39.9434L97.2807 104.078L71.5465 111.213L45.8831 104.088L40.1641 39.9434H103.006Z'
          fill='#E44D26'
        />
        <path
          d='M71.582 105.757L92.3766 99.9918L97.2687 45.1855H71.582V105.757Z'
          fill='#F16529'
        />
        <path
          d='M60.4532 60.9198H71.5824V53.0527H51.8555L52.0437 55.1633L53.9774 76.8429H71.5824V68.9759H61.1722L60.4532 60.9198ZM62.2263 80.7766H54.3289L55.431 93.1292L71.5462 97.6025L71.5824 97.5927V89.4076L71.548 89.4167L62.7864 87.0509L62.2263 80.7766Z'
          fill='#EBEBEB'
        />
        <path
          d='M46.0039 22.5098H50.0019V26.4597H53.6592V22.5098H57.6574V34.4711H53.6594V30.4658H50.0021V34.4711H46.0042L46.0039 22.5098ZM62.9146 26.4764H59.3955V22.5098H70.4346V26.4764H66.9133V34.4711H62.9153V26.4764H62.9146ZM72.1865 22.5098H76.3552L78.9195 26.7127L81.4813 22.5098H85.6517V34.4711H81.67V28.5424L78.9195 32.7953H78.8505L76.0982 28.5424V34.4711H72.1865V22.5098ZM87.6413 22.5098H91.6405V30.5175H97.2628V34.4711H87.6411V22.5098H87.6413Z'
          fill='black'
        />
        <path
          d='M71.5549 76.8429H81.2424L80.329 87.046L71.5547 89.4142V97.5988L87.6828 93.1292L87.801 91.7999L89.65 71.0884L89.8418 68.9759H71.5549V76.8429ZM71.5549 60.9006V60.9198H90.5577L90.7153 59.1517L91.074 55.1633L91.2619 53.0527H71.5549V60.9006Z'
          fill='white'
        />
      </g>
      <g clipPath='url(#clip1_1032_1618)'>
        <path
          d='M178.378 111.011L152.715 103.918L146.996 40.0605H209.838L204.113 103.908L178.378 111.011Z'
          fill='#264DE4'
        />
        <path
          d='M199.213 99.8423L204.105 45.2812H178.418V105.581L199.213 99.8423Z'
          fill='#2965F1'
        />
        <path
          d='M160.112 68.9651L160.817 76.797H178.422V68.9651H160.112ZM158.695 53.1133L159.41 60.9452H178.422V53.1133H158.695ZM178.422 89.3054L178.388 89.3145L169.626 86.9593L169.066 80.7131H161.169L162.271 93.0104L178.386 97.4637L178.422 97.4539V89.3054Z'
          fill='#EBEBEB'
        />
        <path
          d='M161.789 22.707H171.317V26.6739H165.774V30.6407H171.318V34.6073H161.789V22.707ZM173.223 22.707H182.751V26.1564H177.208V26.8463H182.751V34.7799H173.223V31.1576H178.767V30.4678H173.223L173.223 22.707ZM184.657 22.707H194.186V26.1564H188.642V26.8463H194.186V34.7799H184.657V31.1576H190.201V30.4678H184.657V22.707H184.657Z'
          fill='black'
        />
        <path
          d='M196.678 68.9651L198.098 53.1133H178.391V60.9452H189.476L188.76 68.9651H178.391V76.797H188.078L187.165 86.9544L178.391 89.3121V97.4601L194.519 93.0104L194.637 91.6871L196.486 71.0682L196.678 68.9651Z'
          fill='white'
        />
      </g>
      <g clipPath='url(#clip2_1032_1618)'>
        <path
          d='M88.7536 155.209H55.2526C47.0898 155.209 40.4727 161.826 40.4727 169.989V203.49C40.4727 211.653 47.0898 218.27 55.2526 218.27H88.7536C96.9164 218.27 103.534 211.653 103.534 203.49V169.989C103.534 161.826 96.9164 155.209 88.7536 155.209Z'
          fill='#F0DB4F'
        />
        <path
          d='M57.051 207.906L61.8767 204.986C62.8078 206.637 63.6547 208.033 65.6862 208.033C67.6334 208.033 68.8611 207.272 68.8611 204.309V184.159H74.7874V204.392C74.7874 210.53 71.1895 213.324 65.9401 213.324C61.1995 213.324 58.4477 210.869 57.0508 207.906M78.0062 207.271L82.8313 204.478C84.1017 206.552 85.7526 208.076 88.6731 208.076C91.1288 208.076 92.6945 206.848 92.6945 205.155C92.6945 203.123 91.0859 202.403 88.3768 201.218L86.8956 200.583C82.62 198.763 79.7837 196.477 79.7837 191.652C79.7837 187.207 83.1703 183.82 88.4618 183.82C92.2291 183.82 94.9383 185.133 96.8853 188.561L92.2713 191.525C91.2552 189.704 90.155 188.985 88.4618 188.985C86.7261 188.985 85.6255 190.086 85.6255 191.525C85.6255 193.302 86.7261 194.022 89.2658 195.123L90.7472 195.758C95.7844 197.917 98.6207 200.118 98.6207 205.07C98.6207 210.404 94.4301 213.325 88.8002 213.325C83.2974 213.325 79.7416 210.7 78.0062 207.271Z'
          fill='#323330'
        />
      </g>
      <g clipPath='url(#clip3_1032_1618)'>
        <path
          d='M178.418 155.639C161.232 155.639 147.312 169.559 147.312 186.745C147.312 200.509 156.217 212.135 168.581 216.256C170.137 216.529 170.72 215.595 170.72 214.779C170.72 214.04 170.681 211.591 170.681 208.985C162.865 210.424 160.844 207.08 160.221 205.33C159.872 204.436 158.355 201.676 157.033 200.937C155.944 200.354 154.389 198.915 156.994 198.876C159.444 198.837 161.194 201.131 161.777 202.064C164.576 206.769 169.048 205.447 170.836 204.631C171.109 202.609 171.925 201.248 172.819 200.47C165.898 199.693 158.666 197.01 158.666 185.112C158.666 181.729 159.872 178.929 161.855 176.752C161.543 175.974 160.455 172.786 162.166 168.509C162.166 168.509 164.771 167.692 170.72 171.697C173.208 170.997 175.852 170.647 178.496 170.647C181.14 170.647 183.784 170.997 186.273 171.697C192.222 167.653 194.827 168.509 194.827 168.509C196.538 172.786 195.449 175.974 195.138 176.752C197.121 178.929 198.326 181.69 198.326 185.112C198.326 197.049 191.055 199.693 184.134 200.47C185.262 201.442 186.234 203.309 186.234 206.225C186.234 210.385 186.195 213.729 186.195 214.779C186.195 215.595 186.778 216.568 188.334 216.256C194.509 214.172 199.875 210.204 203.677 204.91C207.478 199.615 209.523 193.262 209.524 186.745C209.524 169.559 195.605 155.639 178.418 155.639Z'
          fill='black'
        />
      </g>
      <defs>
        <clipPath id='clip0_1032_1618'>
          <rect
            width='63.0609'
            height='88.9257'
            fill='white'
            transform='translate(40.0508 22.5098)'
          />
        </clipPath>
        <clipPath id='clip1_1032_1618'>
          <rect
            width='63.0609'
            height='88.5278'
            fill='white'
            transform='translate(146.891 22.707)'
          />
        </clipPath>
        <clipPath id='clip2_1032_1618'>
          <rect
            width='63.0609'
            height='63.0609'
            fill='white'
            transform='translate(40.4727 155.213)'
          />
        </clipPath>
        <clipPath id='clip3_1032_1618'>
          <rect
            width='62.212'
            height='62.212'
            fill='white'
            transform='translate(147.312 155.639)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default BeginingsIcon;
